<template>
    <section class="flex flex-col text-base">
        <PageHeader wide>
            <h1>{{ title }}</h1>
        </PageHeader>
        <SiteStaticContent class="container-left max-w-5xl mt-8" :file />
    </section>
</template>
<script setup lang="ts">
const { t } = useI18n();

const {
    file,
    titleKey,
    descriptionKey = undefined,
} = defineProps<{
    file: string;
    titleKey: string;
    descriptionKey?: string;
}>();

const title = t(titleKey);
const description = descriptionKey ? t(descriptionKey) : undefined;

useSeoMeta({ title, ogTitle: title, description, ogDescription: description });
</script>
